export const Placeholder = ({colSpan = 1, placeholder = 'No Data'}) => (
  <tr className="data-list no_result">
    <td className="text-center" colSpan={colSpan}>
      {placeholder}
    </td>
  </tr>
)
